import { Spinner } from '@/components/ui/Spinner'

import { FloatingBar, FloatingButton } from './styles'

interface FloatingCtaBarProps {
  onClick: () => void
  /** CTA 검증 진행 중 — 텍스트 대신 스피너, 브랜드 배경 유지·클릭 차단 */
  loading?: boolean
  /** 재고 소진 — 비활성 + 안내 문구로 전환 */
  soldOut?: boolean
}

export function FloatingCtaBar({ onClick, loading = false, soldOut = false }: FloatingCtaBarProps) {
  const label = (() => {
    if (soldOut) return '업그레이드 된 밀봉비닐로 돌아올게요'
    if (loading) {
      return (
        <Spinner
          size='medium'
          color='#ffffff'
        />
      )
    }
    return '배송비만 결제하고 밀봉비닐 받기'
  })()

  return (
    <FloatingBar>
      <FloatingButton
        type='button'
        soldOut={soldOut}
        aria-busy={loading || undefined}
        aria-disabled={soldOut || undefined}
        onClick={loading || soldOut ? undefined : onClick}
      >
        {label}
      </FloatingButton>
    </FloatingBar>
  )
}
